const registerDependency = async (dependencyNamespace, store) => {
  if (!store.state.hasOwnProperty(dependencyNamespace)) {
    const dep = await import(`$modules/${dependencyNamespace}`)
    await registerModule(dep.default, store)
  }
}

export const registerModule = async (module, store) => {
  if (!module || !module.state || !module.state.namespace) {
    return
  }
  const ns = module.state.namespace
  if (!store.state.hasOwnProperty(ns)) {
    store.registerModule(ns, module)
    // // console.log('> registered ns: ', ns)
  }
  // -- dependencies
  if (module && module.state && module.state.hasOwnProperty('dependencies') && Array.isArray(module.state.dependencies)) {
    // // console.log('------REGISTER DEPENDENCIES-----')
    await Promise.all(module.state.dependencies.map(ns => registerDependency(ns, store)))
  }
}

export default ({ Vue, store }) => {
  Vue.prototype.$registerModule = async module => registerModule(module, store)
}
